export default __webpack_public_path__ + "static/media/fintoc.8e6d9b25.png";